@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_011_158_560)
internal val Res.string.custom_hat_locked_desc: StringResource by lazy {
      StringResource("string:custom_hat_locked_desc", "custom_hat_locked_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16026, 210),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16578, 226),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16938, 234),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15734, 210),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14694, 170),
      ))
    }

@delegate:ResourceContentHash(772_211_712)
internal val Res.string.custom_hat_locked_title: StringResource by lazy {
      StringResource("string:custom_hat_locked_title", "custom_hat_locked_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16237, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16805, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17173, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15945, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14865, 47),
      ))
    }

@delegate:ResourceContentHash(1_345_331_254)
internal val Res.string.custom_hat_type_beret: StringResource by lazy {
      StringResource("string:custom_hat_type_beret", "custom_hat_type_beret", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16285, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16861, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17233, 37),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16001, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14913, 37),
      ))
    }

@delegate:ResourceContentHash(1_611_923_106)
internal val Res.string.custom_hat_type_egypt: StringResource by lazy {
      StringResource("string:custom_hat_type_egypt", "custom_hat_type_egypt", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16331, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16899, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17271, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16039, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14951, 41),
      ))
    }

@delegate:ResourceContentHash(-1_593_751_213)
internal val Res.string.custom_hat_type_explorer: StringResource by lazy {
      StringResource("string:custom_hat_type_explorer", "custom_hat_type_explorer", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16369, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16941, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17313, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16081, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14993, 44),
      ))
    }

@delegate:ResourceContentHash(-263_490_439)
internal val Res.string.custom_hat_type_viking: StringResource by lazy {
      StringResource("string:custom_hat_type_viking", "custom_hat_type_viking", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16414, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16990, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17362, 38),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16130, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15038, 38),
      ))
    }

@delegate:ResourceContentHash(-697_008_945)
internal val Res.string.custom_macchie_type_base: StringResource by lazy {
      StringResource("string:custom_macchie_type_base", "custom_macchie_type_base", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16457, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17033, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17401, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16173, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15077, 44),
      ))
    }

@delegate:ResourceContentHash(849_283_030)
internal val Res.string.custom_macchie_type_tigrato: StringResource by lazy {
      StringResource("string:custom_macchie_type_tigrato", "custom_macchie_type_tigrato", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16502, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17078, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17446, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16218, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15122, 47),
      ))
    }

@delegate:ResourceContentHash(1_593_649_795)
internal val Res.string.custom_macchie_type_tuxedo: StringResource by lazy {
      StringResource("string:custom_macchie_type_tuxedo", "custom_macchie_type_tuxedo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16613, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17189, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17553, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16329, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15233, 42),
      ))
    }

@delegate:ResourceContentHash(384_155_063)
internal val Res.string.custom_macchie_type_tuxedo_tigrato: StringResource by lazy {
      StringResource("string:custom_macchie_type_tuxedo_tigrato", "custom_macchie_type_tuxedo_tigrato", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16550, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17122, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17490, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16266, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15170, 62),
      ))
    }

@delegate:ResourceContentHash(-445_567_452)
internal val Res.string.custom_mask_locked_desc: StringResource by lazy {
      StringResource("string:custom_mask_locked_desc", "custom_mask_locked_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16656, 211),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17236, 227),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17600, 231),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16372, 211),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15276, 175),
      ))
    }

@delegate:ResourceContentHash(-1_763_488_891)
internal val Res.string.custom_mask_locked_title: StringResource by lazy {
      StringResource("string:custom_mask_locked_title", "custom_mask_locked_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16868, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17464, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17832, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16584, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15452, 48),
      ))
    }

@delegate:ResourceContentHash(-1_520_306_613)
internal val Res.string.custom_mask_type_base: StringResource by lazy {
      StringResource("string:custom_mask_type_base", "custom_mask_type_base", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16921, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17521, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17889, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16641, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15501, 41),
      ))
    }

@delegate:ResourceContentHash(1_806_707_063)
internal val Res.string.custom_mask_type_einstein: StringResource by lazy {
      StringResource("string:custom_mask_type_einstein", "custom_mask_type_einstein", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16963, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17563, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17931, 45),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16683, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15543, 45),
      ))
    }

@delegate:ResourceContentHash(1_877_060_754)
internal val Res.string.custom_mask_type_pirata: StringResource by lazy {
      StringResource("string:custom_mask_type_pirata", "custom_mask_type_pirata", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17009, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17609, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17977, 39),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16729, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15589, 39),
      ))
    }

@delegate:ResourceContentHash(1_437_418_798)
internal val Res.string.custom_mask_type_riccone: StringResource by lazy {
      StringResource("string:custom_mask_type_riccone", "custom_mask_type_riccone", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17049, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17649, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18017, 40),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16769, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15629, 40),
      ))
    }

@delegate:ResourceContentHash(-495_421_880)
internal val Res.string.custom_pattern_locked_desc: StringResource by lazy {
      StringResource("string:custom_pattern_locked_desc", "custom_pattern_locked_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17090, 218),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17690, 230),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18058, 234),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 16814, 214),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15670, 182),
      ))
    }

@delegate:ResourceContentHash(605_984_609)
internal val Res.string.custom_pattern_locked_title: StringResource by lazy {
      StringResource("string:custom_pattern_locked_title", "custom_pattern_locked_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17309, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17921, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18293, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17029, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15853, 55),
      ))
    }

@delegate:ResourceContentHash(935_463_680)
internal val Res.string.custom_title_bg: StringResource by lazy {
      StringResource("string:custom_title_bg", "custom_title_bg", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17365, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17981, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18353, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17085, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15909, 39),
      ))
    }

@delegate:ResourceContentHash(-1_224_941_104)
internal val Res.string.custom_title_body: StringResource by lazy {
      StringResource("string:custom_title_body", "custom_title_body", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17405, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18013, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18397, 33),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17117, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15949, 33),
      ))
    }

@delegate:ResourceContentHash(760_230_832)
internal val Res.string.custom_title_ear_left: StringResource by lazy {
      StringResource("string:custom_title_ear_left", "custom_title_ear_left", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17443, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18047, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18431, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17151, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15983, 41),
      ))
    }

@delegate:ResourceContentHash(1_685_833_085)
internal val Res.string.custom_title_ear_right: StringResource by lazy {
      StringResource("string:custom_title_ear_right", "custom_title_ear_right", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17489, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18097, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18481, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17205, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16025, 42),
      ))
    }

@delegate:ResourceContentHash(1_755_574_823)
internal val Res.string.custom_title_earrings: StringResource by lazy {
      StringResource("string:custom_title_earrings", "custom_title_earrings", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17536, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18148, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18532, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17256, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16068, 41),
      ))
    }

@delegate:ResourceContentHash(-2_138_282_103)
internal val Res.string.custom_title_example: StringResource by lazy {
      StringResource("string:custom_title_example", "custom_title_example", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17578, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18194, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18586, 40),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17298, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16110, 40),
      ))
    }

@delegate:ResourceContentHash(-1_758_193_736)
internal val Res.string.custom_title_eyebrows: StringResource by lazy {
      StringResource("string:custom_title_eyebrows", "custom_title_eyebrows", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17619, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18235, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18627, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17339, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16151, 41),
      ))
    }

@delegate:ResourceContentHash(-290_646_196)
internal val Res.string.custom_title_eyes: StringResource by lazy {
      StringResource("string:custom_title_eyes", "custom_title_eyes", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17665, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18273, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18669, 33),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17385, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16193, 33),
      ))
    }

@delegate:ResourceContentHash(1_046_902_154)
internal val Res.string.custom_title_face: StringResource by lazy {
      StringResource("string:custom_title_face", "custom_title_face", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17699, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18307, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18703, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17419, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16227, 49),
      ))
    }

@delegate:ResourceContentHash(-1_468_997_246)
internal val Res.string.custom_title_glasses: StringResource by lazy {
      StringResource("string:custom_title_glasses", "custom_title_glasses", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17855, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18483, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18883, 40),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17587, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16387, 40),
      ))
    }

@delegate:ResourceContentHash(-123_748_299)
internal val Res.string.custom_title_glasses_accent: StringResource by lazy {
      StringResource("string:custom_title_glasses_accent", "custom_title_glasses_accent", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17749, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18373, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18761, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17473, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16277, 55),
      ))
    }

@delegate:ResourceContentHash(159_315_923)
internal val Res.string.custom_title_glasses_type: StringResource by lazy {
      StringResource("string:custom_title_glasses_type", "custom_title_glasses_type", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17805, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18429, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18825, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17533, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16333, 53),
      ))
    }

@delegate:ResourceContentHash(691_906_481)
internal val Res.string.custom_title_hair: StringResource by lazy {
      StringResource("string:custom_title_hair", "custom_title_hair", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17892, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18520, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18924, 37),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17628, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16428, 33),
      ))
    }

@delegate:ResourceContentHash(-1_867_659_754)
internal val Res.string.custom_title_hat: StringResource by lazy {
      StringResource("string:custom_title_hat", "custom_title_hat", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18012, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18668, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19072, 36),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17772, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16552, 28),
      ))
    }

@delegate:ResourceContentHash(291_154_440)
internal val Res.string.custom_title_hat_accent: StringResource by lazy {
      StringResource("string:custom_title_hat_accent", "custom_title_hat_accent", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17926, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18554, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18962, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17666, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16462, 47),
      ))
    }

@delegate:ResourceContentHash(-620_455)
internal val Res.string.custom_title_hat_type: StringResource by lazy {
      StringResource("string:custom_title_hat_type", "custom_title_hat_type", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17970, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18614, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19018, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17722, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16510, 41),
      ))
    }

@delegate:ResourceContentHash(924_125_745)
internal val Res.string.custom_title_head: StringResource by lazy {
      StringResource("string:custom_title_head", "custom_title_head", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18041, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18705, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19109, 33),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17809, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16581, 33),
      ))
    }

@delegate:ResourceContentHash(-1_834_452_608)
internal val Res.string.custom_title_macchie_type: StringResource by lazy {
      StringResource("string:custom_title_macchie_type", "custom_title_macchie_type", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18075, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18739, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19143, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17843, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16615, 45),
      ))
    }

@delegate:ResourceContentHash(-1_316_603_082)
internal val Res.string.custom_title_mask_type: StringResource by lazy {
      StringResource("string:custom_title_mask_type", "custom_title_mask_type", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18117, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18785, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19185, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17885, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16661, 46),
      ))
    }

@delegate:ResourceContentHash(1_645_694_956)
internal val Res.string.custom_title_mouth: StringResource by lazy {
      StringResource("string:custom_title_mouth", "custom_title_mouth", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18164, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18840, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19236, 34),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17936, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16708, 34),
      ))
    }

@delegate:ResourceContentHash(-7_888_837)
internal val Res.string.custom_title_nose: StringResource by lazy {
      StringResource("string:custom_title_nose", "custom_title_nose", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18199, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18875, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19271, 29),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17971, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16743, 33),
      ))
    }

@delegate:ResourceContentHash(906_643_907)
internal val Res.string.custom_title_shirt: StringResource by lazy {
      StringResource("string:custom_title_shirt", "custom_title_shirt", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18233, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18909, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19301, 38),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18005, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16777, 38),
      ))
    }

@delegate:ResourceContentHash(182_951_164)
internal val Res.string.custom_title_spot_left: StringResource by lazy {
      StringResource("string:custom_title_spot_left", "custom_title_spot_left", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18272, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18948, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19340, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18044, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16816, 42),
      ))
    }

@delegate:ResourceContentHash(2_088_313_023)
internal val Res.string.custom_title_spot_right: StringResource by lazy {
      StringResource("string:custom_title_spot_right", "custom_title_spot_right", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18319, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19003, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19387, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18099, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16859, 47),
      ))
    }

@delegate:ResourceContentHash(-1_612_408_597)
internal val Res.string.custom_title_whiskers: StringResource by lazy {
      StringResource("string:custom_title_whiskers", "custom_title_whiskers", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18371, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19055, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19435, 45),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18151, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16907, 41),
      ))
    }

@delegate:ResourceContentHash(278_394_152)
internal val Res.string.daily_bonus_free_btn: StringResource by lazy {
      StringResource("string:daily_bonus_free_btn", "daily_bonus_free_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18417, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19097, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19481, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18189, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16949, 52),
      ))
    }

@delegate:ResourceContentHash(341_983_704)
internal val Res.string.daily_bonus_free_desc_streak_active: StringResource by lazy {
      StringResource("string:daily_bonus_free_desc_streak_active", "daily_bonus_free_desc_streak_active", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18470, 183),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19154, 187),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19542, 187),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18246, 187),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17002, 167),
      ))
    }

@delegate:ResourceContentHash(-781_299_179)
internal val Res.string.daily_bonus_free_desc_streak_zero: StringResource by lazy {
      StringResource("string:daily_bonus_free_desc_streak_zero", "daily_bonus_free_desc_streak_zero", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18654, 169),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19342, 165),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19730, 161),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18434, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17170, 149),
      ))
    }

@delegate:ResourceContentHash(-2_009_549_083)
internal val Res.string.daily_bonus_free_hearts: StringResource by lazy {
      StringResource("string:daily_bonus_free_hearts", "daily_bonus_free_hearts", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18824, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19508, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19892, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18588, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17320, 43),
      ))
    }

@delegate:ResourceContentHash(-1_426_557_934)
internal val Res.string.daily_bonus_free_title: StringResource by lazy {
      StringResource("string:daily_bonus_free_title", "daily_bonus_free_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18868, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19556, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19936, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18632, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17364, 46),
      ))
    }

@delegate:ResourceContentHash(256_033_717)
internal val Res.string.daily_bonus_pro_btn: StringResource by lazy {
      StringResource("string:daily_bonus_pro_btn", "daily_bonus_pro_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18923, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19603, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19987, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18687, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17411, 39),
      ))
    }

@delegate:ResourceContentHash(-1_196_050_493)
internal val Res.string.daily_bonus_pro_desc_streak_active: StringResource by lazy {
      StringResource("string:daily_bonus_pro_desc_streak_active", "daily_bonus_pro_desc_streak_active", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18967, 198),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19643, 166),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20035, 178),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18727, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17451, 162),
      ))
    }

@delegate:ResourceContentHash(-1_765_605_405)
internal val Res.string.daily_bonus_pro_desc_streak_zero: StringResource by lazy {
      StringResource("string:daily_bonus_pro_desc_streak_zero", "daily_bonus_pro_desc_streak_zero", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19166, 164),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19810, 148),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20214, 160),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18894, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17614, 132),
      ))
    }

@delegate:ResourceContentHash(-1_225_346_137)
internal val Res.string.daily_bonus_pro_title: StringResource by lazy {
      StringResource("string:daily_bonus_pro_title", "daily_bonus_pro_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19331, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19959, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20375, 45),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19047, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17747, 49),
      ))
    }

@delegate:ResourceContentHash(57_915_153)
internal val Res.string.daily_fire_bonus_coins: StringResource by lazy {
      StringResource("string:daily_fire_bonus_coins", "daily_fire_bonus_coins", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19389, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20025, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20421, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19093, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17797, 50),
      ))
    }

@delegate:ResourceContentHash(-1_119_185_797)
internal val Res.string.daily_fire_desc: StringResource by lazy {
      StringResource("string:daily_fire_desc", "daily_fire_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19440, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20076, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20472, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19144, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17848, 99),
      ))
    }

@delegate:ResourceContentHash(-571_447_120)
internal val Res.string.daily_fire_strike_1: StringResource by lazy {
      StringResource("string:daily_fire_strike_1", "daily_fire_strike_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19552, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20172, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20572, 95),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19240, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17948, 87),
      ))
    }

@delegate:ResourceContentHash(1_795_577_425)
internal val Res.string.daily_fire_strike_many: StringResource by lazy {
      StringResource("string:daily_fire_strike_many", "daily_fire_strike_many", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19660, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20264, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20668, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19340, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18036, 90),
      ))
    }

@delegate:ResourceContentHash(-1_288_474_854)
internal val Res.string.daily_fire_title: StringResource by lazy {
      StringResource("string:daily_fire_title", "daily_fire_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19771, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20359, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20767, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19443, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18127, 44),
      ))
    }

@delegate:ResourceContentHash(993_102_211)
internal val Res.string.daily_review_btn: StringResource by lazy {
      StringResource("string:daily_review_btn", "daily_review_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19820, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20404, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20820, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19492, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18172, 40),
      ))
    }

@delegate:ResourceContentHash(274_931_961)
internal val Res.string.day_friday_short: StringResource by lazy {
      StringResource("string:day_friday_short", "day_friday_short", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19869, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20449, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20869, 28),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19537, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18213, 28),
      ))
    }

@delegate:ResourceContentHash(-1_542_867_027)
internal val Res.string.day_monday_short: StringResource by lazy {
      StringResource("string:day_monday_short", "day_monday_short", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19898, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20478, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20898, 28),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19566, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18242, 28),
      ))
    }

@delegate:ResourceContentHash(2_079_920_482)
internal val Res.string.day_saturday_short: StringResource by lazy {
      StringResource("string:day_saturday_short", "day_saturday_short", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19927, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20507, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20927, 30),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19595, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18271, 30),
      ))
    }

@delegate:ResourceContentHash(2_026_265_717)
internal val Res.string.day_sunday_short: StringResource by lazy {
      StringResource("string:day_sunday_short", "day_sunday_short", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19958, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20538, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20958, 28),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19626, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18302, 28),
      ))
    }

@delegate:ResourceContentHash(-1_842_002_827)
internal val Res.string.day_thursday_short: StringResource by lazy {
      StringResource("string:day_thursday_short", "day_thursday_short", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19987, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20567, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20987, 30),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19655, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18331, 30),
      ))
    }

@delegate:ResourceContentHash(-1_575_313_795)
internal val Res.string.day_tuesday_short: StringResource by lazy {
      StringResource("string:day_tuesday_short", "day_tuesday_short", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20018, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20598, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21018, 29),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19686, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18362, 29),
      ))
    }

@delegate:ResourceContentHash(1_134_993_108)
internal val Res.string.day_wednesday_short: StringResource by lazy {
      StringResource("string:day_wednesday_short", "day_wednesday_short", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20048, 31),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20628, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21048, 31),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19716, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18392, 31),
      ))
    }

@delegate:ResourceContentHash(-124_049_224)
internal val Res.string.dot_completed: StringResource by lazy {
      StringResource("string:dot_completed", "dot_completed", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20080, 25),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20660, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21080, 25),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19748, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18424, 25),
      ))
    }

@delegate:ResourceContentHash(-724_307_069)
internal val Res.string.dot_pending: StringResource by lazy {
      StringResource("string:dot_pending", "dot_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20106, 23),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20686, 23),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21106, 23),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19774, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18450, 23),
      ))
    }

@delegate:ResourceContentHash(-122_140_614)
internal val Res.string.dot_wrong: StringResource by lazy {
      StringResource("string:dot_wrong", "dot_wrong", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20130, 21),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20710, 21),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21130, 21),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19798, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18474, 21),
      ))
    }

@delegate:ResourceContentHash(-1_453_990_866)
internal val Res.string.email_label: StringResource by lazy {
      StringResource("string:email_label", "email_label", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20152, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20732, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21152, 27),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19820, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18496, 27),
      ))
    }

@delegate:ResourceContentHash(411_714_428)
internal val Res.string.email_placeholder: StringResource by lazy {
      StringResource("string:email_placeholder", "email_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20180, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20780, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21180, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19848, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18524, 49),
      ))
    }

@delegate:ResourceContentHash(1_262_876_730)
internal val Res.string.empty_explanation_desc: StringResource by lazy {
      StringResource("string:empty_explanation_desc", "empty_explanation_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20230, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20830, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21230, 94),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19898, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18574, 82),
      ))
    }

@delegate:ResourceContentHash(-927_025_174)
internal val Res.string.errori_correggi_btn: StringResource by lazy {
      StringResource("string:errori_correggi_btn", "errori_correggi_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20317, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20913, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21325, 39),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19985, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18657, 39),
      ))
    }

@delegate:ResourceContentHash(1_460_096_763)
internal val Res.string.errori_empty_state: StringResource by lazy {
      StringResource("string:errori_empty_state", "errori_empty_state", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20361, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20953, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21365, 94),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20025, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18697, 66),
      ))
    }

@delegate:ResourceContentHash(-559_732_787)
internal val Res.string.errori_ready_state: StringResource by lazy {
      StringResource("string:errori_ready_state", "errori_ready_state", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20527, 94),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21115, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21551, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20191, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18855, 86),
      ))
    }

@delegate:ResourceContentHash(663_630_327)
internal val Res.string.errori_ready_state_one: StringResource by lazy {
      StringResource("string:errori_ready_state_one", "errori_ready_state_one", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20428, 98),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21032, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21460, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20104, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18764, 90),
      ))
    }

@delegate:ResourceContentHash(-333_965_889)
internal val Res.string.exchange_hearts_btn_label: StringResource by lazy {
      StringResource("string:exchange_hearts_btn_label", "exchange_hearts_btn_label", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20622, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21202, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21642, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20278, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18942, 73),
      ))
    }

@delegate:ResourceContentHash(1_354_202_553)
internal val Res.string.exp_content_a_differenza_del_genitivo_qui_non_c_un_rapporto_di:
    StringResource by lazy {
      StringResource("string:exp_content_a_differenza_del_genitivo_qui_non_c_un_rapporto_di", "exp_content_a_differenza_del_genitivo_qui_non_c_un_rapporto_di", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20700, 194),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21280, 190),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21720, 190),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20352, 182),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19016, 178),
      ))
    }

@delegate:ResourceContentHash(709_341_902)
internal val Res.string.exp_content_a_volte_al_posto_della_u_si_potevano_trovare_: StringResource by
    lazy {
      StringResource("string:exp_content_a_volte_al_posto_della_u_si_potevano_trovare_", "exp_content_a_volte_al_posto_della_u_si_potevano_trovare_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20895, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21471, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21911, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20535, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19195, 141),
      ))
    }

@delegate:ResourceContentHash(2_033_538_579)
internal val Res.string.exp_content_a_volte_gli_scribi_aggiungevano_segni_silenzi: StringResource by
    lazy {
      StringResource("string:exp_content_a_volte_gli_scribi_aggiungevano_segni_silenzi", "exp_content_a_volte_gli_scribi_aggiungevano_segni_silenzi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21037, 281),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21621, 257),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22061, 265),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20685, 265),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19337, 245),
      ))
    }

@delegate:ResourceContentHash(-2_031_492_524)
internal val Res.string.exp_content_accostiamo_la_parola_per_mucca_iht_a_quella_p: StringResource by
    lazy {
      StringResource("string:exp_content_accostiamo_la_parola_per_mucca_iht_a_quella_p", "exp_content_accostiamo_la_parola_per_mucca_iht_a_quella_p", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21319, 197),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21879, 189),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22327, 209),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20951, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19583, 197),
      ))
    }

@delegate:ResourceContentHash(-569_918_808)
internal val Res.string.exp_content_accostiamo_semplicemente_la_parola_per_vino_i: StringResource by
    lazy {
      StringResource("string:exp_content_accostiamo_semplicemente_la_parola_per_vino_i", "exp_content_accostiamo_semplicemente_la_parola_per_vino_i", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21517, 241),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22069, 225),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22537, 241),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21149, 233),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19781, 225),
      ))
    }

@delegate:ResourceContentHash(-59_580_657)
internal val Res.string.exp_content_ad_esempio_ecco_uno_dei_cartigli_del_famosissimo_tutankhamon:
    StringResource by lazy {
      StringResource("string:exp_content_ad_esempio_ecco_uno_dei_cartigli_del_famosissimo_tutankhamon", "exp_content_ad_esempio_ecco_uno_dei_cartigli_del_famosissimo_tutankhamon", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21759, 172),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22295, 180),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22779, 176),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21383, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20007, 172),
      ))
    }

@delegate:ResourceContentHash(-874_221_619)
internal val Res.string.exp_content_aggettivi_genere_1: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_1", "exp_content_aggettivi_genere_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22992, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23484, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23956, 114),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22512, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21176, 98),
      ))
    }

@delegate:ResourceContentHash(1_943_543_727)
internal val Res.string.exp_content_aggettivi_genere_10: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_10", "exp_content_aggettivi_genere_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21932, 139),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22476, 115),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22956, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21548, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20180, 119),
      ))
    }

@delegate:ResourceContentHash(-865_722_945)
internal val Res.string.exp_content_aggettivi_genere_11: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_11", "exp_content_aggettivi_genere_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22072, 135),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22592, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23080, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21668, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20300, 127),
      ))
    }

@delegate:ResourceContentHash(1_605_567_740)
internal val Res.string.exp_content_aggettivi_genere_12: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_12", "exp_content_aggettivi_genere_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22208, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22724, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23208, 115),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21788, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20428, 115),
      ))
    }

@delegate:ResourceContentHash(-1_538_543_987)
internal val Res.string.exp_content_aggettivi_genere_13: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_13", "exp_content_aggettivi_genere_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22324, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22848, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23324, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21904, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20544, 83),
      ))
    }

@delegate:ResourceContentHash(-1_569_725_107)
internal val Res.string.exp_content_aggettivi_genere_14: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_14", "exp_content_aggettivi_genere_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22408, 135),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22936, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23404, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21984, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20628, 115),
      ))
    }

@delegate:ResourceContentHash(-486_131_729)
internal val Res.string.exp_content_aggettivi_genere_15: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_15", "exp_content_aggettivi_genere_15", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22544, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23060, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23524, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22104, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20744, 87),
      ))
    }

@delegate:ResourceContentHash(1_531_052_193)
internal val Res.string.exp_content_aggettivi_genere_16: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_16", "exp_content_aggettivi_genere_16", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22640, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23156, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23616, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22196, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20832, 87),
      ))
    }

@delegate:ResourceContentHash(-426_840_469)
internal val Res.string.exp_content_aggettivi_genere_17: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_17", "exp_content_aggettivi_genere_17", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22732, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23248, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23708, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22288, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20920, 111),
      ))
    }

@delegate:ResourceContentHash(-1_133_885_214)
internal val Res.string.exp_content_aggettivi_genere_18: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_18", "exp_content_aggettivi_genere_18", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22844, 147),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23368, 115),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23828, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22404, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21032, 143),
      ))
    }

@delegate:ResourceContentHash(-966_158_854)
internal val Res.string.exp_content_aggettivi_genere_2: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_2", "exp_content_aggettivi_genere_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23119, 138),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23603, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24071, 150),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22627, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21275, 114),
      ))
    }

@delegate:ResourceContentHash(-1_282_464_235)
internal val Res.string.exp_content_aggettivi_genere_3: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_3", "exp_content_aggettivi_genere_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23258, 138),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23734, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24222, 142),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22754, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21390, 122),
      ))
    }

@delegate:ResourceContentHash(1_903_001_194)
internal val Res.string.exp_content_aggettivi_genere_4: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_4", "exp_content_aggettivi_genere_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23397, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23865, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24365, 130),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22885, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21513, 118),
      ))
    }

@delegate:ResourceContentHash(-1_089_097_817)
internal val Res.string.exp_content_aggettivi_genere_5: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_5", "exp_content_aggettivi_genere_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23508, 90),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23984, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24496, 94),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23004, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21632, 86),
      ))
    }

@delegate:ResourceContentHash(-1_581_918_530)
internal val Res.string.exp_content_aggettivi_genere_6: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_6", "exp_content_aggettivi_genere_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23599, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24083, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24591, 138),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23091, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21719, 122),
      ))
    }

@delegate:ResourceContentHash(-1_678_362_916)
internal val Res.string.exp_content_aggettivi_genere_7: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_7", "exp_content_aggettivi_genere_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23726, 146),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24218, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24730, 142),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23234, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21842, 150),
      ))
    }

@delegate:ResourceContentHash(288_329_122)
internal val Res.string.exp_content_aggettivi_genere_8: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_8", "exp_content_aggettivi_genere_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23873, 90),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24357, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24873, 118),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23365, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21993, 82),
      ))
    }

@delegate:ResourceContentHash(274_069_825)
internal val Res.string.exp_content_aggettivi_genere_9: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_genere_9", "exp_content_aggettivi_genere_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23964, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24448, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24992, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23448, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22076, 118),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("custom_hat_locked_desc", Res.string.custom_hat_locked_desc)
  map.put("custom_hat_locked_title", Res.string.custom_hat_locked_title)
  map.put("custom_hat_type_beret", Res.string.custom_hat_type_beret)
  map.put("custom_hat_type_egypt", Res.string.custom_hat_type_egypt)
  map.put("custom_hat_type_explorer", Res.string.custom_hat_type_explorer)
  map.put("custom_hat_type_viking", Res.string.custom_hat_type_viking)
  map.put("custom_macchie_type_base", Res.string.custom_macchie_type_base)
  map.put("custom_macchie_type_tigrato", Res.string.custom_macchie_type_tigrato)
  map.put("custom_macchie_type_tuxedo", Res.string.custom_macchie_type_tuxedo)
  map.put("custom_macchie_type_tuxedo_tigrato", Res.string.custom_macchie_type_tuxedo_tigrato)
  map.put("custom_mask_locked_desc", Res.string.custom_mask_locked_desc)
  map.put("custom_mask_locked_title", Res.string.custom_mask_locked_title)
  map.put("custom_mask_type_base", Res.string.custom_mask_type_base)
  map.put("custom_mask_type_einstein", Res.string.custom_mask_type_einstein)
  map.put("custom_mask_type_pirata", Res.string.custom_mask_type_pirata)
  map.put("custom_mask_type_riccone", Res.string.custom_mask_type_riccone)
  map.put("custom_pattern_locked_desc", Res.string.custom_pattern_locked_desc)
  map.put("custom_pattern_locked_title", Res.string.custom_pattern_locked_title)
  map.put("custom_title_bg", Res.string.custom_title_bg)
  map.put("custom_title_body", Res.string.custom_title_body)
  map.put("custom_title_ear_left", Res.string.custom_title_ear_left)
  map.put("custom_title_ear_right", Res.string.custom_title_ear_right)
  map.put("custom_title_earrings", Res.string.custom_title_earrings)
  map.put("custom_title_example", Res.string.custom_title_example)
  map.put("custom_title_eyebrows", Res.string.custom_title_eyebrows)
  map.put("custom_title_eyes", Res.string.custom_title_eyes)
  map.put("custom_title_face", Res.string.custom_title_face)
  map.put("custom_title_glasses", Res.string.custom_title_glasses)
  map.put("custom_title_glasses_accent", Res.string.custom_title_glasses_accent)
  map.put("custom_title_glasses_type", Res.string.custom_title_glasses_type)
  map.put("custom_title_hair", Res.string.custom_title_hair)
  map.put("custom_title_hat", Res.string.custom_title_hat)
  map.put("custom_title_hat_accent", Res.string.custom_title_hat_accent)
  map.put("custom_title_hat_type", Res.string.custom_title_hat_type)
  map.put("custom_title_head", Res.string.custom_title_head)
  map.put("custom_title_macchie_type", Res.string.custom_title_macchie_type)
  map.put("custom_title_mask_type", Res.string.custom_title_mask_type)
  map.put("custom_title_mouth", Res.string.custom_title_mouth)
  map.put("custom_title_nose", Res.string.custom_title_nose)
  map.put("custom_title_shirt", Res.string.custom_title_shirt)
  map.put("custom_title_spot_left", Res.string.custom_title_spot_left)
  map.put("custom_title_spot_right", Res.string.custom_title_spot_right)
  map.put("custom_title_whiskers", Res.string.custom_title_whiskers)
  map.put("daily_bonus_free_btn", Res.string.daily_bonus_free_btn)
  map.put("daily_bonus_free_desc_streak_active", Res.string.daily_bonus_free_desc_streak_active)
  map.put("daily_bonus_free_desc_streak_zero", Res.string.daily_bonus_free_desc_streak_zero)
  map.put("daily_bonus_free_hearts", Res.string.daily_bonus_free_hearts)
  map.put("daily_bonus_free_title", Res.string.daily_bonus_free_title)
  map.put("daily_bonus_pro_btn", Res.string.daily_bonus_pro_btn)
  map.put("daily_bonus_pro_desc_streak_active", Res.string.daily_bonus_pro_desc_streak_active)
  map.put("daily_bonus_pro_desc_streak_zero", Res.string.daily_bonus_pro_desc_streak_zero)
  map.put("daily_bonus_pro_title", Res.string.daily_bonus_pro_title)
  map.put("daily_fire_bonus_coins", Res.string.daily_fire_bonus_coins)
  map.put("daily_fire_desc", Res.string.daily_fire_desc)
  map.put("daily_fire_strike_1", Res.string.daily_fire_strike_1)
  map.put("daily_fire_strike_many", Res.string.daily_fire_strike_many)
  map.put("daily_fire_title", Res.string.daily_fire_title)
  map.put("daily_review_btn", Res.string.daily_review_btn)
  map.put("day_friday_short", Res.string.day_friday_short)
  map.put("day_monday_short", Res.string.day_monday_short)
  map.put("day_saturday_short", Res.string.day_saturday_short)
  map.put("day_sunday_short", Res.string.day_sunday_short)
  map.put("day_thursday_short", Res.string.day_thursday_short)
  map.put("day_tuesday_short", Res.string.day_tuesday_short)
  map.put("day_wednesday_short", Res.string.day_wednesday_short)
  map.put("dot_completed", Res.string.dot_completed)
  map.put("dot_pending", Res.string.dot_pending)
  map.put("dot_wrong", Res.string.dot_wrong)
  map.put("email_label", Res.string.email_label)
  map.put("email_placeholder", Res.string.email_placeholder)
  map.put("empty_explanation_desc", Res.string.empty_explanation_desc)
  map.put("errori_correggi_btn", Res.string.errori_correggi_btn)
  map.put("errori_empty_state", Res.string.errori_empty_state)
  map.put("errori_ready_state", Res.string.errori_ready_state)
  map.put("errori_ready_state_one", Res.string.errori_ready_state_one)
  map.put("exchange_hearts_btn_label", Res.string.exchange_hearts_btn_label)
  map.put("exp_content_a_differenza_del_genitivo_qui_non_c_un_rapporto_di", Res.string.exp_content_a_differenza_del_genitivo_qui_non_c_un_rapporto_di)
  map.put("exp_content_a_volte_al_posto_della_u_si_potevano_trovare_", Res.string.exp_content_a_volte_al_posto_della_u_si_potevano_trovare_)
  map.put("exp_content_a_volte_gli_scribi_aggiungevano_segni_silenzi", Res.string.exp_content_a_volte_gli_scribi_aggiungevano_segni_silenzi)
  map.put("exp_content_accostiamo_la_parola_per_mucca_iht_a_quella_p", Res.string.exp_content_accostiamo_la_parola_per_mucca_iht_a_quella_p)
  map.put("exp_content_accostiamo_semplicemente_la_parola_per_vino_i", Res.string.exp_content_accostiamo_semplicemente_la_parola_per_vino_i)
  map.put("exp_content_ad_esempio_ecco_uno_dei_cartigli_del_famosissimo_tutankhamon", Res.string.exp_content_ad_esempio_ecco_uno_dei_cartigli_del_famosissimo_tutankhamon)
  map.put("exp_content_aggettivi_genere_1", Res.string.exp_content_aggettivi_genere_1)
  map.put("exp_content_aggettivi_genere_10", Res.string.exp_content_aggettivi_genere_10)
  map.put("exp_content_aggettivi_genere_11", Res.string.exp_content_aggettivi_genere_11)
  map.put("exp_content_aggettivi_genere_12", Res.string.exp_content_aggettivi_genere_12)
  map.put("exp_content_aggettivi_genere_13", Res.string.exp_content_aggettivi_genere_13)
  map.put("exp_content_aggettivi_genere_14", Res.string.exp_content_aggettivi_genere_14)
  map.put("exp_content_aggettivi_genere_15", Res.string.exp_content_aggettivi_genere_15)
  map.put("exp_content_aggettivi_genere_16", Res.string.exp_content_aggettivi_genere_16)
  map.put("exp_content_aggettivi_genere_17", Res.string.exp_content_aggettivi_genere_17)
  map.put("exp_content_aggettivi_genere_18", Res.string.exp_content_aggettivi_genere_18)
  map.put("exp_content_aggettivi_genere_2", Res.string.exp_content_aggettivi_genere_2)
  map.put("exp_content_aggettivi_genere_3", Res.string.exp_content_aggettivi_genere_3)
  map.put("exp_content_aggettivi_genere_4", Res.string.exp_content_aggettivi_genere_4)
  map.put("exp_content_aggettivi_genere_5", Res.string.exp_content_aggettivi_genere_5)
  map.put("exp_content_aggettivi_genere_6", Res.string.exp_content_aggettivi_genere_6)
  map.put("exp_content_aggettivi_genere_7", Res.string.exp_content_aggettivi_genere_7)
  map.put("exp_content_aggettivi_genere_8", Res.string.exp_content_aggettivi_genere_8)
  map.put("exp_content_aggettivi_genere_9", Res.string.exp_content_aggettivi_genere_9)
}
